jQuery(document).ready(function() {
  
  jQuery('ul.tabs').each(function(){
      var active, content, links = jQuery(this).find('a');
      active = links.first().addClass('active');
      content = jQuery(active.attr('href'));
      links.not(':first').each(function () {
        jQuery(jQuery(this).attr('href')).hide();
      });
      jQuery(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = jQuery(this);
        content = jQuery(jQuery(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });

  ////// Light Box ////////
  lightbox.option({
      'fitImagesInViewport': true
    })
  
  //// Ends Light Box ////
  
  ////// Applications Slider ////////
jQuery('.art-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  centerMode: true,
  variableWidth: true,
  infinite: true,
  focusOnSelect: true,
  cssEase: 'linear',
  touchMove: true,
  prevArrow:'<button class="slick-prev"> < </button>',
  nextArrow:'<button class="slick-next"> > </button>',
  
  //         responsive: [                        
  //             {
  //               breakpoint: 576,
  //               settings: {
  //                 centerMode: false,
  //                 variableWidth: false,
  //               }
  //             },
  //         ]
});


var imgs = jQuery('.art-slider img');
imgs.each(function(){
  var item = jQuery(this).closest('.art-item');
  item.css({
    'background-image': 'url(' + jQuery(this).attr('src') + ')', 
    'background-position': 'center',            
    '-webkit-background-size': 'cover',
    'background-size': 'cover', 
  });
  jQuery(this).hide();
});
  
  //// Ends Applications Slider ////
  
  
  //var $col_carousel = jQuery('.collection-listing .product-list.carousel');
 // $col_carousel.data('owl.carousel').options.items= 4;
 /*$col_carousel.owlCarousel({

    items: 4,
    margin: 30,
    autoplay: false,
    autoplayTimeout: 2000,
    smartSpeed: 500,
    autoplaySpeed: 1000,
    loop: true,
   	nav: true,
    dots: false,
    responsiveClass: true,
    responsive: {
        992: {
            item: 4,
            nav: false,
            dots: true,
            margin: 25
        },
        768: {
            items: 3,
          	nav: false,
            dots: true,
            margin: 15
        },
        320: {
            items: 1,
          	nav: false,
            dots: true,
            margin: 0
        }
    }
});*/
   
   // fix for event propagation in nested owl carousels
      //theme.beforeCarouselLoadEventBlockFix($col_carousel);
// run after carousel is initialised
/* $col_carousel.on('initialized.owl.carousel', function(){

   // restore data-src
	$col_carousel.find('[data-src-temp]').each(function(){
		jQuery(this).attr('data-src', jQuery(this).attr('data-src-temp')).removeAttr('data-src-temp');
	});
	// lazysizes
 	$col_carousel.find('.lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');
	// ensure clones are processed from scratch
	theme.ProductBlockManager.loadImages($col_carousel.closest('[data-section-type]'));
	// recalculate widths, after the above's async calls
	setTimeout(function(){
		$col_carousel.data('owl.carousel').invalidate('width');
 		$col_carousel.trigger('refresh.owl.carousel');
		}, 10);
        
		console.log("restore OK");
	});
  
  */
  
//jQuery('.collection-listing .product-list.carousel').trigger( 'refresh.owl.carousel' );
  
  //console.log(jQuery('.collection-listing .product-list.owl-carousel').);

});
